import React from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import ResultPlace from '../ResultPlace/ResultPlace';
import './GamePage.css';

const GamePage = (props) => {
    let GameId = props.imgId;
    let countQuestion = props.rightAnswer.length;
    let countCorrect = 0;
    for(let i = 0; i < props.rightAnswer.length; i++) {
        if (props.rightAnswer[i] === 1) countCorrect++;
    }
    let classBtn1 = 'Answer1 ';
    let classBtn2 = 'Answer1 Answer2 ';
    let imgAnswer = 'AnswerCircle1 ';

    if (props.disabled) {
        if ((props.rightButton === 0) && (props.rightAnswer[props.step] === 1)) {
            classBtn1 += 'Answer';
            imgAnswer = imgAnswer + 'rightImg';
        };
        
        if ((props.rightButton === 1) && (props.rightAnswer[props.step] === 2)) {
            classBtn1 += 'Wrong';
            imgAnswer = imgAnswer + 'wrongImg';
        }
        
        if ((props.rightButton === 1) && (props.rightAnswer[props.step] === 1)) {
            classBtn2 += 'Answer';
            imgAnswer = imgAnswer + 'AnswerCircle2 rightImg';
        }
        
        if ((props.rightButton === 0) && (props.rightAnswer[props.step] === 2)) {
            classBtn2 += 'Wrong';
            imgAnswer = imgAnswer + 'AnswerCircle2 wrongImg';
        }
    }
    
   
    let answer = ((props.rightButton === 0) ? (<div>
   
        <Button className={classBtn1} disabled={props.disabled} onClick={() => props.onClick('answer')} value={props.content[GameId][props.lang].answer} /> 
        <Button className={classBtn2} disabled={props.disabled} onClick={() => props.onClick('wrong')} value={props.content[GameId][props.lang].wrong} />
            </div>) :  (<div>
            <Button className={classBtn2} disabled={props.disabled} onClick={() => props.onClick('answer')} value={props.content[GameId][props.lang].answer} /> 
            <Button className={classBtn1} disabled={props.disabled} onClick={() => props.onClick('wrong')} value={props.content[GameId][props.lang].wrong} />
           </div>) );
   
    return (
        <div>
            <img src={props.bgSrc} className= 'bgImg' alt = ' ' />
            <img  src = {props.src} className = {props.NewImg ? 'gameImg imgAnimation' : 'gameImg'} alt = ' ' />
            <div className = 'resultConting'>{countCorrect} / {countQuestion}</div>
             <ResultPlace  rightAnswer = {props.rightAnswer} step = {props.step}/>
            <Text className='Question' value={props.content[GameId][props.lang].question} /> 
            <Text className='imgName' value={props.content[GameId][props.lang].name} />
             {answer}
            <Button className = 'GameNext'  onClick = {() => props.onClick('next')} hidden = {!props.disabled} /> 
             <div className = {imgAnswer} hidden = {!props.disabled} > </div>
        </div>
    );
    };

export default GamePage;